/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash'

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCommandPOCsByCommandID(commandID) {
  const response = await $.soap({
    body: {
      GetCommandPOCsByCommandID: {
        $xmlns: 'http://dla.mil/ems/bpm/command',
        CommandID: commandID
      },
    },
    blueprintArrays : [
    'GetCommandPOCsByCommandIDResponse.tuple'
    ],
    blueprint: {
      pocs: ['$..GetCommandPOCsByCommandIDResponse.tuple', {
        id: '$.old.CommandPOC.ID',
        typeID: '$.old.CommandPOC.TypeID',
        type: '$.old.CommandPOC.Type',
        firstName: '$.old.CommandPOC.FirstName',
        lastName: '$.old.CommandPOC.LastName',
        email: '$.old.CommandPOC.Email',
        telephone: '$.old.CommandPOC.Telephone',
        orgUnit: '$.old.CommandPOC.OrgUnit',
      }]
    }
  });

  _.each(response.pocs, (poc) => {
    poc.name = `${poc.firstName} ${poc.lastName}`
  })

  cleanUpResponse(response);
  return response.pocs;
}
